import { 
    SET_APPS,
    SET_CATEGORIES 
} from '../types'

const reducer = (state, action) => {
    
    switch (action.type) {
        
        case SET_CATEGORIES:
            return {
                ...state,
                categories: action.payload
            }

        case SET_APPS:
            return{
                ...state,
                apps: action.payload
            }
    
        default: return state
    }

}

export default reducer